module.exports = __webpack_public_path__ + "img/virusColectivo10.eaa0c76c.jpg";